var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{ref:"leftEl",staticClass:"draggable-abs",style:({ left: _vm.left + 'px', position: 'absolute' })},[_c('v-icon',[_vm._v("mdi-drag")])],1),_c('span',{ref:"rightEl",staticClass:"draggable-abs",style:({ left: _vm.right + 'px', position: 'absolute' })},[_c('v-icon',[_vm._v("mdi-drag")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }